import styled from 'styled-components';

export const TextEmbedWrapper = styled.div``;

export const TextEmbedItem = styled.a.attrs({
  href: ''
})``;
